import { type Meta } from '../types/docs';

const META: Meta = {
  description: "An author removed an external link from a collection share link's navigation",
  name: 'header_link_removed',
};

export default META;
